import { Facebook, Phone, MapPin, Heart, Lock } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="mt-24 bg-brand-ink text-white" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="mb-4 inline-block bg-white rounded-2xl p-2 border-[3px] border-brand-yellow">
            <Logo size={64} />
          </div>
          <p className="text-white/80 max-w-md leading-relaxed">
            An English-based playgroup with Islamic ethos in Ridgeway, Johannesburg. 
            Nurturing curious little minds for over 20 years.
          </p>
        </div>

        <div>
          <h4 className="font-display text-lg mb-3 text-brand-yellow">Visit us</h4>
          <a
            href="https://maps.google.com/?q=Faan+Street+Ridgeway+Johannesburg"
            target="_blank"
            rel="noreferrer"
            className="flex items-start gap-2 text-white/85 hover:text-brand-yellow"
            data-testid="footer-address"
          >
            <MapPin size={18} className="mt-1 shrink-0" />
            Faan Street, Ridgeway,<br/>Johannesburg, South Africa
          </a>
          <a
            href="tel:0846702322"
            className="flex items-center gap-2 mt-3 text-white/85 hover:text-brand-yellow"
            data-testid="footer-phone"
          >
            <Phone size={18} /> 084 670 2322
          </a>
        </div>

        <div>
          <h4 className="font-display text-lg mb-3 text-brand-yellow">Follow us</h4>
          <a
            href="https://www.facebook.com/cheekymonkeysridgeway"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-white text-brand-ink font-bold px-4 py-2 border-[3px] border-brand-yellow hover:-translate-y-0.5 transition-transform"
            data-testid="footer-facebook"
          >
            <Facebook size={18} /> Facebook
          </a>
          <p className="text-white/60 text-sm mt-4">
            Tuesdays, Wednesdays, Thursdays<br/>9:00 am – 12:00 pm
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-6xl px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-sm text-white/60">
          <p>© {new Date().getFullYear()} Cheeky Monkeys Playgroup Ridgeway. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <p className="flex items-center gap-1">Made with <Heart size={14} className="text-brand-red" fill="#EF476F" /> in Johannesburg</p>
            <Link
              to="/admin/login"
              data-testid="footer-admin-link"
              className="inline-flex items-center gap-1 rounded-full border border-white/20 px-3 py-1 text-white/60 hover:text-brand-yellow hover:border-brand-yellow transition-colors"
            >
              <Lock size={12} /> Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
